/**
 * @author he jia
 * @date 2025-05-20
 * @description 项目完善信息
 */

import { observable, makeObservable, action } from 'mobx';
import { isBusinessNeedVerify, getImproveInformationDetail, saveImproveInformation, getAllArea } from '@/api/improveInformation';
import dayjs from 'dayjs';
class ImproveInformation {
    constructor() {
        makeObservable(this);
    }
    @observable state = {
        dynamicForm: [],
        initialValues: {},
        projectEndFlag: false
    };
    @action setState = (data) => {
        this.state = Object.assign({}, this.state, data);
    };

    // 判断是否需要完善信息
    isNeedimproveInformation = async (data) => {
        //true：已完善 false:需要完善
        let isNeedVerify = false;
        const { success, data: resData } = await isBusinessNeedVerify(data);
        if (success && resData !== true) {
            isNeedVerify = true;
        }
        return isNeedVerify;
    };

    // 获取完善信息详情
    getImproveInformationDetail = async (data) => {
        let isArea = false;
        let areaList = [];

        const { success, data: resData } = await getImproveInformationDetail(data);
        if (success) {
            let initialValues = resData.improve_list.reduce((acc, item) => {
                acc[item.en_name] = item.value;
                return acc;
            }, {});

            resData.improve_list.forEach((ele) => {
                // 日期类型
                if (ele.field_type === 5 && initialValues[ele.en_name]) {
                    if (ele.setting.type === 'range') {
                        let [start, end] = initialValues[ele.en_name];
                        initialValues[ele.en_name] = [dayjs(start), dayjs(end)];
                    } else {
                        initialValues[ele.en_name] = dayjs(initialValues[ele.en_name]);
                    }
                }
                if (
                    ele.field_type === 4 &&
                    (ele.setting['data_source'] === 'province_city_district' ||
                        ele.setting['data_source'] === 'province_city' ||
                        ele.setting['data_source'] === 'province') &&
                    ele.value?.length
                ) {
                    isArea = true;
                    areaList.push(ele);
                }
            });
            if (isArea) {
                const allArea = await getAllArea();

                areaList.forEach((ele) => {
                    let name = ele.en_name + '_name';
                    initialValues[name] = [];
                    ele.value.forEach((item) => {
                        initialValues[name].push(allArea.data.find((area) => area.code === item)?.name);
                    });
                });
            }
            // project_end_flag true 已结束，false 未结束
            this.setState({
                dynamicForm: resData.improve_list,
                initialValues: initialValues,
                projectEndFlag: resData.project_end_flag
            });
        }
    };

    // 保存完善信息
    saveImproveInformation = async (data) => {
        return await saveImproveInformation(data);
    };
}
export default new ImproveInformation();
